module.exports = __webpack_public_path__ + "static/img/meishi1.4cc5adb7.jpg";